import { Link } from "react-router-dom";
import ScrollReveal from "@/components/base/ScrollReveal";

export default function ContactCta() {
  return (
    <section className="w-full bg-background-100 py-20 md:py-28">
      <div className="mx-auto w-full max-w-7xl px-6 md:px-12 lg:px-20">
        <ScrollReveal>
          <div className="flex flex-col items-center text-center">
            <span className="font-label text-xs tracking-[0.4em] text-secondary-500">
              お問い合わせ
            </span>
            <h2 className="mt-6 font-display text-4xl font-light tracking-[0.08em] text-foreground-950 md:text-6xl">
              CONTACT
            </h2>
            <p className="mt-8 max-w-xl font-body text-sm leading-[2.2] text-foreground-700">
              事業のご相談、協業のご提案、採用に関するご質問など、
              お気軽にお問い合わせください。担当者より折り返しご連絡いたします。
            </p>
            <Link
              to="/contact"
              className="mt-10 inline-flex items-center gap-3 whitespace-nowrap bg-foreground-950 px-10 py-4 font-body text-[12px] tracking-[0.24em] text-background-50 transition-colors hover:bg-accent-600"
            >
              お問い合わせフォームへ
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}